import ActionButton from 'components/ActionButton';
import Checkbox from 'components/FormFields/checkbox';
import WholeNumberInput from 'components/WholeNumberInput';
import _ from 'lodash';
import React, { useState } from 'react';
import { markInventorySpotCheck } from 'services';
import { showError } from 'utils';
import styles from './index.module.scss';

const InventoryItemQuantity = (props) => {
  const { setIsChecked, inventoryItem, inventoryAddressState, isChecked } = props;
  const {
    objectId,
    active: activeStatus = false,
    stock = 0,
    unfulfilledStock = 0,
  } = inventoryItem;
  const [newQuantity, setNewQuantity] = useState(parseInt(stock) ? parseInt(stock) : 0);
  const [newUnfulfilledStock, setNewUnfulfilledQuantity] = useState(
    parseInt(unfulfilledStock) ? parseInt(unfulfilledStock) : 0,
  );
  const [active, setActive] = useState(activeStatus);
    
  const markInventorySpotCheckFn = async () => {
    try {
      setIsChecked(true);
      await markInventorySpotCheck({
        inventoryItemId: objectId,
        quantity: newQuantity,
        unfulfilledStock: newUnfulfilledStock,
        active,
        startInventoryAddress: inventoryAddressState?.start,
        endInventoryAddress: inventoryAddressState?.end,
      });
    } catch (e) {
      showError(e);
      setIsChecked(false);
    }
  };
      
  const getQuantity = () => {
    if (isChecked) {
      return (
        <div>
          <div className={styles['input-label']}>Quantity</div>
          {newQuantity}
        </div>
      );
    }
    return (
      <div>
        <div className={styles['input-label']}>Quantity</div>
        <WholeNumberInput
          value={newQuantity}
          onChange={setNewQuantity}
          inputProps={{ pattern: 'd*' }}
        />
      </div>
    );
  };
    
  const getUnFulfilledQuantity = () => {
    if (isChecked) {
      return (
        <div>
          <div className={styles['input-label']}>Unfulfilled Quantity</div>
          {newUnfulfilledStock}
        </div>
      );
    }
    return (
      <div>
        <div className={styles['input-label']}>Unfulfilled Quantity</div>
        <WholeNumberInput
          value={newUnfulfilledStock}
          onChange={setNewUnfulfilledQuantity}
          inputProps={{ pattern: 'd*' }}
        />
      </div>
    );
  };
    
  const getActiveInput = () => {
    if (isChecked) {
      return (
        <div>
          <div className={styles['input-label']}>Active</div>
          {active ? 'Active' : 'Inactive'}
        </div>
      );
    }
    return (
      <div>
        <div className={styles['input-label']}>Active</div>
        <Checkbox title="" isChecked={active} setIsChecked={setActive} />
      </div>
    );
  };
      
  const getCheckButton = () => {
    if (isChecked || _.isNaN(newQuantity) || _.isNaN(newUnfulfilledStock))
      return null;
    return (
      <div className={styles['check-button']}>
        <ActionButton
          text="Check"
          onClick={markInventorySpotCheckFn}
          isLoading={false}
          active={true}
          customClass={styles['button']}
        />
      </div>
    );
  };

  const getAddressString = (address = {} as any) => {
    const { storageSection, furnitureNo, shelfNo } = address;
    if (!storageSection || !furnitureNo || !shelfNo) return;
    return `${storageSection}${furnitureNo}.${shelfNo}`;
  };

  const isInventoryAddressChangedFn = () => {
    const oldAddressStartString = inventoryItem?.inventoryAddress?.start?.addressString;
    const oldAddressEndString = inventoryItem?.inventoryAddress?.end?.addressString;
    const newAddressStartString = getAddressString(inventoryAddressState?.start);
    const newAddressEndString = getAddressString(inventoryAddressState?.end);
    if (oldAddressStartString === newAddressStartString && oldAddressEndString ===newAddressEndString) {
      return false;
    } else {
      return true;
    }
  };

  const getNewInventoryAddress = () => {
    const isInventoryAddressChanged = isInventoryAddressChangedFn();
    if (!isInventoryAddressChanged) return;
    return (
      <div>
        New Inventory Address: {getAddressString(inventoryAddressState?.start)} - {getAddressString(inventoryAddressState?.end)}
      </div>
    );
  };

  return (
    <>
      {getNewInventoryAddress()}
      <div className={`${styles['actions']}`}>
        {getActiveInput()}
        {getQuantity()}
        {getUnFulfilledQuantity()}
      </div>
      {getCheckButton()}
    </>
  );
};

export default InventoryItemQuantity;
